import { useAuth } from "@/hooks/useAuth";

/**
 * Возвращает true для сотрудников платформы (ADMIN, MANAGER, ACCOUNTANT)
 * и false для клиентов-организаций (CLIENT) и неавторизованных пользователей.
 *
 * Используется для скрытия внутренних UI-элементов (например, кнопок
 * «Заполнить тестовыми данными») от клиентских аккаунтов.
 */
export function useIsStaff(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.role !== "CLIENT";
}
